import './blockbite-frontend.css';

import PureCounter from '@srexi/purecounterjs';

document.addEventListener('DOMContentLoaded', function () {
  const pure = new PureCounter();

  // for animation
  motionObserver();

  // for interaction
  interactionListener();
});

const motionObserver = () => {
  // get all items with prefix .animate- class
  const items = document.querySelectorAll('[class*="animate-"]');

  // check when items are in viewport
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };
  // create observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      // check if item is in viewport
      if (entry.isIntersecting) {
        // add animate class
        entry.target.classList.add('animated');
        entry.target.style.animationPlayState = 'running';
        observer.unobserve(entry.target);
      }
    });
  }, options);

  // Observe each element
  items.forEach((element) => {
    if (element) {
      observer.observe(element);
    }
  });
};

const interactionListener = () => {
  const interactionBlocks = document.querySelectorAll('[data-b_action_type]');
  const clickBlocks = [...interactionBlocks].filter(
    (block) => block.dataset.b_action_type === 'click'
  );
  const hoverBlocks = [...interactionBlocks].filter(
    (block) => block.dataset.b_action_type === 'hover'
  );

  clickBlocks.forEach((block) => {
    block.addEventListener('click', (e) => {
      e.currentTarget.classList.toggle('b_active');

      if (block.dataset.b_action_ref) {
        const refBlocks = document.querySelectorAll(
          `.${block.dataset.b_action_ref}`
        );
        refBlocks.forEach((refBlock) => {
          refBlock.classList.toggle('b_active');
        });
      }
    });
  });

  hoverBlocks.forEach((block) => {
    block.addEventListener('mouseenter', (e) => {
      e.currentTarget.classList.add('b_active');

      if (block.dataset.b_action_ref) {
        const refBlocks = document.querySelectorAll(
          `.${block.dataset.b_action_ref}`
        );
        refBlocks.forEach((refBlock) => {
          refBlock.classList.add('b_active');
        });
      }
    });
    block.addEventListener('mouseleave', (e) => {
      e.currentTarget.classList.remove('b_active');

      if (block.dataset.b_action_ref) {
        const refBlocks = document.querySelectorAll(
          `.${block.dataset.b_action_ref}`
        );
        refBlocks.forEach((refBlock) => {
          refBlock.classList.remove('b_active');
        });
      }
    });
  });
};
